import { Skeleton } from '@/shared/components/ui/skeleton';
import { useLingui } from '@lingui/react/macro';

/**
 * Loading placeholder for {@link UploadsPage}, shown as the route's
 * `pendingComponent` while the loader warms the uploads + cloud-imports history
 * queries. Mirrors the page shell: header + two history sections.
 */
export function UploadsPageSkeleton() {
  const { t } = useLingui();
  return (
    <div className="flex flex-col gap-6 p-6" aria-label={t`Loading transfers`}>
      <header className="flex items-center justify-between">
        <Skeleton className="h-6 w-32" />
        <Skeleton className="h-8 w-32" />
      </header>
      <section className="space-y-5">
        {[0, 1].map((section) => (
          <div key={section} className="space-y-2">
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-9 w-full" />
            <Skeleton className="h-9 w-full" />
          </div>
        ))}
      </section>
    </div>
  );
}
